<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <form [formGroup]="formGroup" (submit)="submit()" class="tw-p-4">
    <div mat-dialog-title class="matp-dialog-title">
      {{ roleName }}{{ updating ? "編集" : "新規登録" }}
    </div>

    <mat-dialog-content class="tw-w-full !tw-pt-2">
      <div class="tw-flex tw-gap-x-4">
        <div class="tw-flex tw-flex-col tw-gap-y-6 tw-w-full">
          <!-- テナント選択 -->
          @if(userType==="tenant_admin" && loggedInUserRole === "system_admin" )
          {
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            [ngClass]="{ 'matp-form-field-readonly': updating }"
          >
            <mat-label>テナント</mat-label>
            <mat-select
              formControlName="tenantId"
              name="tenantId"
              [required]="!updating"
            >
              @for(tenant of tenantList; track tenant.tenantId) {
              <mat-option [value]="tenant.tenantId">
                {{ tenant.tenantName }}
              </mat-option>
              }
            </mat-select>
            <mat-error
              *ngIf="formGroup.controls.tenantId?.errors?.['required']"
            >
              テナントを選択してください。
            </mat-error>
          </mat-form-field>
          }

          <div class="tw-flex tw-gap-2">
            <!-- 姓入力 -->
            <mat-form-field
              appearance="outline"
              floatLabel="always"
              class="tw-w-full"
            >
              <mat-label>姓</mat-label>
              <input
                matInput
                formControlName="familyName"
                placeholder="例）田中"
                name="familyName"
                required
              />
              <mat-error
                *ngIf="formGroup.controls.familyName.errors?.['required']"
              >
                姓を入力してください。
              </mat-error>
              <mat-error
                *ngIf="formGroup.controls.familyName.errors?.['maxlength']"
              >
                32文字以内で入力してください。
              </mat-error>
            </mat-form-field>

            <!-- 名入力 -->
            <mat-form-field
              appearance="outline"
              floatLabel="always"
              class="tw-w-full"
            >
              <mat-label>名</mat-label>
              <input
                matInput
                formControlName="givenName"
                placeholder="例）太郎"
                name="givenName"
                required
              />
              <mat-error
                *ngIf="formGroup.controls.givenName.errors?.['required']"
              >
                名を入力してください。
              </mat-error>
              <mat-error
                *ngIf="formGroup.controls.givenName.errors?.['maxlength']"
              >
                32文字以内で入力してください。
              </mat-error>
            </mat-form-field>
          </div>

          <div class="tw-flex tw-gap-2">
            <!-- セイ入力 -->
            <mat-form-field
              appearance="outline"
              floatLabel="always"
              class="tw-w-full"
            >
              <mat-label>セイ</mat-label>
              <input
                matInput
                formControlName="familyNameKana"
                placeholder="例）タナカ"
                name="familyNameKana"
                required
              />
              <mat-error
                *ngIf="formGroup.controls.familyNameKana.errors?.['required']"
              >
                セイを入力してください。
              </mat-error>
              <mat-error
                *ngIf="formGroup.controls.familyNameKana.errors?.['maxlength']"
              >
                32文字以内で入力してください。
              </mat-error>
              <mat-error
                *ngIf="formGroup.controls.familyNameKana.errors?.['pattern']"
              >
                カタカナ、英数字、記号で入力してください。
              </mat-error>
            </mat-form-field>

            <!-- メイ入力 -->
            <mat-form-field
              appearance="outline"
              floatLabel="always"
              class="tw-w-full"
            >
              <mat-label>メイ</mat-label>
              <input
                matInput
                formControlName="givenNameKana"
                placeholder="例）タロウ"
                name="givenNameKana"
                required
              />
              <mat-error
                *ngIf="formGroup.controls.givenNameKana.errors?.['required']"
              >
                メイを入力してください。
              </mat-error>
              <mat-error
                *ngIf="formGroup.controls.givenNameKana.errors?.['maxlength']"
              >
                32文字以内で入力してください。
              </mat-error>
              <mat-error
                *ngIf="formGroup.controls.givenNameKana.errors?.['pattern']"
              >
                カタカナ、英数字、記号で入力してください。
              </mat-error>
            </mat-form-field>
          </div>

          <!-- メールアドレス入力 -->
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            [ngClass]="{ 'matp-form-field-readonly': updating }"
          >
            <mat-label>メールアドレス</mat-label>
            <input
              matInput
              formControlName="email"
              placeholder="例）user@example.com"
              name="email"
              [required]="!updating"
              [readonly]="updating"
            />
            <mat-error *ngIf="formGroup.controls.email.errors?.['required']">
              メールアドレスを入力してください。
            </mat-error>
            <mat-error *ngIf="formGroup.controls.email.errors?.['email']">
              メールアドレスの形式で入力してください。
            </mat-error>
            <mat-error *ngIf="formGroup.controls.email.errors?.['maxlength']">
              メールアドレスは128文字以内で入力してください。
            </mat-error>
          </mat-form-field>

          <!-- 2要素認証設定スイッチ -->
          <mat-slide-toggle
            color="primary"
            [checked]="formGroup.controls.mfa"
            formControlName="mfa"
          >
            2要素認証設定
          </mat-slide-toggle>
        </div>

        @if(userType === "tenant_user") {
        <div class="tw-flex tw-flex-col tw-gap-y-4 tw-w-full">
          <!-- 設定権限スイッチ -->
          <mat-slide-toggle
            color="primary"
            checked="true"
            formControlName="configurable"
          >
            設定権限
          </mat-slide-toggle>

          <!-- 選択された閲覧可能タグ表示 -->
          <div>
            <mat-label>閲覧可能タグ</mat-label>
            <mat-form-field
              appearance="outline"
              floatLabel="always"
              class="tw-w-full"
            >
              <input
                placeholder="選択してください"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipGrid"
                [formControl]="deviceKeywordCtrl"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onSelectedDeviceTag($event)"
              >
                @for (tag of filteredDeviceTagList | async; track tag) { @if
                (!formGroup.get("deviceTagList")?.value?.includes(tag.tagId)) {
                <mat-option [value]="tag.tagId"><span class="tw-rounded tw-p-1" [ngStyle]="tagStyle(tag.color)">{{ tag.tagName }}</span></mat-option>
                } }
              </mat-autocomplete>
              <mat-chip-grid #chipGrid aria-label="Enter keywords">
                @for (tag of filteredDeviceTagList | async; track tag) { @if
                (formGroup.get("deviceTagList")?.value?.includes(tag.tagId)) {
                <mat-chip-row [ngStyle]="tagStyle(tag.color)">
                  {{ tag.tagName }}
                  <button matChipRemove (click)="removeDeviceTag(tag.tagId)">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
                } }
              </mat-chip-grid>
            </mat-form-field>
          </div>
        </div>
        }
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
      <button
        id="cancel-btn"
        mat-raised-button
        mat-dialog-close
        class="tw-w-40"
      >
        <mat-icon>close</mat-icon>
        キャンセル
      </button>
      <button
        id="edit-btn"
        mat-raised-button
        color="accent"
        class="tw-w-40"
        type="submit"
        [disabled]="formGroup.invalid"
      >
        <mat-icon>done</mat-icon>
        <span>{{ updating ? "変更" : "新規登録" }}</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
